export const SET_COMISSIONS_CONFIG = 'COMISSIONS_CONFIG/SET_COMISSIONS_CONFIG';
export const CLEAR_COMISSIONS_CONFIG = 'COMISSIONS_CONFIG/CLEAR_COMISSIONS_CONFIG';
export const SET_COMISSIONS_CONFIG_LOADING = 'COMISSIONS_CONFIG/SET_COMISSIONS_CONFIG_LOADING';
export const SET_COMISSIONS_ERRORS = 'COMISSIONS_CONFIG/SET_COMISSIONS_ERRORS';
export const CLEAR_COMISSIONS_ERRORS = 'COMISSIONS_CONFIG/CLEAR_COMISSIONS_ERRORS';